import { render, staticRenderFns } from "./PartProgramIntializer.vue?vue&type=template&id=6163e09e&"
import script from "./PartProgramIntializer.vue?vue&type=script&lang=js&"
export * from "./PartProgramIntializer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports